// Vuex dashboard module mutations

import {
  FILL_ELEMENTS_LIST,
  FILL_LIVE_LIST,
  FILL_WIRETAPPING_UUID,
} from './mutations-types';

export default {
  [FILL_ELEMENTS_LIST](state, payload) {
    const _state = state;
    _state.elementsIds = payload;
  },
  [FILL_LIVE_LIST](state, payload) {
    const _state = state;
    _state.liveList = payload;
  },
  [FILL_WIRETAPPING_UUID](state, payload) {
    const _state = state;
    _state.wiretappingUuid = payload;
  }
};
